import TyCalEmpty from './TyCalEmpty';

const TyCalWeekNoData = () => {
  return (
    <TyCalEmpty
      className="col-span-full gap-6 h-full flex items-center justify-center flex-col"
      show={true}
      text="Žádné směny s tímto nastavením v tento termín nebyly a nejsou naplánovány."
    />
  );
};

export default TyCalWeekNoData;
